import classNames from "classnames";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { IconName } from "PFTheme/graphics/icons";

import css from "./custom_value_pill_tooltip.module.scss";

type InlineIconTextProps = {
  iconName: IconName;
  text: string;
  white?: boolean;
};

export const InlineIconText = ({ iconName, text, white }: InlineIconTextProps) => (
  <Inline alignItems="center">
    <Icon name={iconName} color={white ? "paletteWhite0" : undefined} size="sm" />
    <Typography
      variant="labelBold"
      className={classNames(css.text, { [css.white]: white })}
      textOverflow="clip"
    >
      {text}
    </Typography>
  </Inline>
);
